import React, { FC } from 'react';
import cx from 'classnames';
import { MenuMyIcon } from '@move-ui/icons-asset-catalog';
import { ImageLoader } from '@move-ui/image-loader';
import { getImageUrl } from '@move-web-essentials-utils/images';
import styles from './Avatar.css';

type Props = {
  avatar?: string;
  className?: string;
  isBranded?: boolean;
  username?: string;
};

const Avatar: FC<Props> = ({
  avatar,
  className,
  isBranded,
  username
}): JSX.Element => {
  if (avatar) {
    return (
      <div
        className={cx(
          styles.avatar,
          {
            [styles.brandedAvatar]: isBranded
          },
          className
        )}
      >
        <ImageLoader
          title={username}
          src={getImageUrl(avatar, { size: 96 })}
          className={styles.image}
        />
      </div>
    );
  }
  return (
    <div
      className={cx(
        styles.icon,
        {
          [styles.brandedIcon]: isBranded
        },
        className
      )}
    >
      <MenuMyIcon />
    </div>
  );
};

export default Avatar;
